// extracted by mini-css-extract-plugin
export var btn = "Features-module--btn--ccaac";
export var btnOutlinePrimary = "Features-module--btn-outline-primary--b0bb2";
export var btnPrimary = "Features-module--btn-primary--7fd0b";
export var card = "Features-module--card--f7437";
export var formSelect = "Features-module--form-select--1bb0c";
export var grey = "Features-module--grey--5bbc0";
export var grid = "Features-module--grid--4b141";
export var head = "Features-module--head--7aa03";
export var heading = "Features-module--heading--04709";
export var inner = "Features-module--inner--de0ef";
export var lead = "Features-module--lead--d0d13";
export var more = "Features-module--more--b1947";
export var section = "Features-module--section--12f8a";
export var text = "Features-module--text--fc546";
export var title = "Features-module--title--4139f";